import './Container.css';

/** Contenedor centrado de ancho máximo, reutilizable en todas las páginas. */
export default function Container({ children, narrow = false, className = '' }) {
  return (
    <div className={`container ${narrow ? 'container-narrow' : ''} ${className}`}>
      {children}
    </div>
  );
}